import { Button2 } from "@/ui2/atoms/Button";

export function EllipsisTile() {
  return (
    <Button2
      className="tw:size-8 tw:rounded-lg tw:text-sm tw:font-medium tw:text-text-tertiary"
      isInert
      variant="blank"
    >
      …
    </Button2>
  );
}
